"use client"
import { useEffect, Suspense } from "react"
import { useRouter, useSearchParams } from "next/navigation"
import { saveToken, fetchMe } from "@/lib/api"

function HomeInner() {
  const router = useRouter()
  const params = useSearchParams()

  useEffect(() => {
    const token = params.get("token")
    if (token) {
      saveToken(token)
      window.history.replaceState({}, "", "/")
    }
    fetchMe().then((user) => {
      router.replace(user ? "/chat" : "/login")
    })
  }, [router, params])

  return (
    <div className="flex h-full items-center justify-center text-gray-500 text-sm">
      Loading...
    </div>
  )
}

export default function HomePage() {
  return (
    <Suspense>
      <HomeInner />
    </Suspense>
  )
}
